import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type OpenableControls } from '../../../../../generic-hooks'

import { DynamicProductPagePrescriptionTypeSelectionModalContent } from './DynamicProductPagePrescriptionTypeSelectionModalContent'

type ErxTypeSelectModalProps = {
  controls: Pick<OpenableControls, 'handleClose' | 'isOpen'>
}

export const ProductPagePrescriptionTypeSelectionModal: FC<
  ErxTypeSelectModalProps
> = ({ controls }) => {
  return (
    <Dialog
      data-qa-id="rxSelectModal"
      onClose={controls.handleClose}
      open={controls.isOpen}
    >
      <DialogTitle onClose={controls.handleClose}>
        <FormattedMessage id="rxSelectModal.title" />
      </DialogTitle>
      <DialogContent>
        <DynamicProductPagePrescriptionTypeSelectionModalContent />
      </DialogContent>
    </Dialog>
  )
}
